import { useEffect, useRef, useState } from "react";
import ApiClient from "../methods/api/apiClient";

const CategoryFilters = ({ filters, setFilters }: any) => {
    const [categories, setCategories] = useState<any[]>([]);
    const [expandedCategoryIds, setExpandedCategoryIds] = useState<string[]>([]);
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        getCategories();
    }, []);

    useEffect(() => {
        const handleDocClick = (e: MouseEvent) => {
            if (!containerRef.current) return;
            if (!containerRef.current.contains(e.target as Node)) {
                setExpandedCategoryIds([]);
            }
        };
        document.addEventListener("mousedown", handleDocClick);
        return () => document.removeEventListener("mousedown", handleDocClick);
    }, []);

    const getCategories = () => {
        ApiClient.get(`category/listing?status=active`).then((res: any) => {
            if (res.success) {
                setCategories(res?.data || []);
            }
        });
    };

    const hanldeFilters = (id: string, check: boolean, key: string) => {
        let idsArray = Array.isArray(filters[key]) ? [...filters[key]] : [];
        const el = document.getElementById("premiumGreeting");
        if (el && check === true) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        if (check) {
            if (!idsArray.includes(id)) idsArray.push(id);
            if (key === "categoryId") {
                const selectedCategory: any = categories.find(
                    (cat: any) => (cat?.id || cat?._id) === id
                );
                const subIds =
                    selectedCategory?.subcategories?.map((sub: any) => sub?.id || sub?._id) ||
                    [];
                setFilters((prev: any) => ({
                    ...prev,
                    [key]: idsArray,
                    subCategoryId: Array.from(new Set([...(prev.subCategoryId || []), ...subIds])),
                }));
            } else {
                setFilters((prev: any) => ({ ...prev, [key]: idsArray }));
            }
        } else {
            idsArray = idsArray.filter((item: any) => item !== id);
            if (key === "categoryId") {
                const deselectedCategory: any = categories.find(
                    (cat: any) => (cat?.id || cat?._id) === id
                );
                const subIds =
                    deselectedCategory?.subcategories?.map((sub: any) => sub?.id || sub?._id) ||
                    [];
                setFilters((prev: any) => ({
                    ...prev,
                    [key]: idsArray,
                    subCategoryId: (prev?.subCategoryId || []).filter(
                        (subId: string) => !subIds.includes(subId)
                    ),
                }));
            } else {
                setFilters((prev: any) => ({ ...prev, [key]: idsArray }));
            }
        }
    };

    const toggleCategory = (id: string) => {
        setExpandedCategoryIds(prev =>
            prev.includes(id) ? prev.filter(cid => cid !== id) : [...prev, id]
        );
    };

    return (
        <div ref={containerRef} className="mb-3 flex gap-2 flex-wrap items-start justify-center relative">
            {categories?.map((item: any, index: number) => {
                const categoryId = item?.id || item?._id;
                const isExpanded = expandedCategoryIds.includes(categoryId);

                return (
                    <div className="mb-2 relative" key={categoryId || index}>
                        <div className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300 flex items-center select-none">
                            <input
                                type="checkbox"
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e: any) => hanldeFilters(categoryId, e.target.checked, 'categoryId')}
                                checked={filters?.categoryId?.includes(categoryId)}
                                className="custom-check w-4 h-4 mr-2 cursor-pointer appearance-none border border-[#F58D18] rounded checked:bg-[#F58D18] checked:border-[#F58D18] relative"
                            />
                            <button
                                type="button"
                                onClick={() => toggleCategory(categoryId)}
                                className="flex items-center gap-1 p-0 text-sm cursor-pointer bg-transparent border-0"
                                aria-expanded={isExpanded}
                                aria-controls={`subcats-${categoryId}`}
                            >
                                <span>{item?.name || "--"}</span>
                                {item?.subcategories?.length > 0 &&
                                    <span className="text-xs">{isExpanded ? "▲" : "▼"}</span>
                                }
                            </button>
                        </div>
                        {isExpanded && item?.subcategories?.length > 0 && (
                            <div
                                id={`subcats-${categoryId}`}
                                className="absolute left-0 top-full mt-1 bg-white border rounded shadow-md w-48 z-50"
                                style={{ minWidth: 200 }}
                            >
                                {item.subcategories.map((sub: any, i: number) => {
                                    const subId = sub?._id || sub?.id;
                                    return (
                                        <div
                                            key={subId || i}
                                            className="flex items-center py-2 px-3 hover:bg-[#f3f3f3] hover:text-[#F58D18] cursor-pointer"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const isChecked = filters?.subCategoryId?.includes(subId);
                                                hanldeFilters(subId, !isChecked, 'subCategoryId');
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={(e) => hanldeFilters(subId, e.target.checked, 'subCategoryId')}
                                                checked={filters?.subCategoryId?.includes(subId)}
                                                className="custom-check w-4 h-4 mr-2 cursor-pointer appearance-none border border-[#F58D18] rounded checked:bg-[#F58D18] checked:border-[#F58D18] relative"
                                            />
                                            <span className="text-sm">{sub?.name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default CategoryFilters;
